import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { cn } from '../../utils/cn';
import { ActionBar } from './ActionBar';

/**
 * Detail drill-down header with back button, title, and responsive actions.
 */
export function DetailPageHeader({
  className,
  onBack,
  backLabel = 'Back',
  title,
  description,
  actions,
}) {
  return (
    <div
      className={cn(
        'flex min-w-0 flex-col gap-4 sm:flex-row sm:items-start sm:justify-between sm:gap-4',
        className
      )}
    >
      <div className="flex min-w-0 items-start gap-3">
        <button
          type="button"
          onClick={onBack}
          className="inline-flex min-h-[44px] min-w-[44px] shrink-0 touch-manipulation items-center justify-center rounded-xl p-2 transition-colors hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
          title={backLabel}
          aria-label={backLabel}
        >
          <ArrowLeft className="h-5 w-5 text-slate-600" aria-hidden />
        </button>
        <div className="min-w-0">
          <h2 className="text-xl font-black tracking-tight text-slate-900 sm:text-2xl">{title}</h2>
          {description ? (
            <p className="mt-1 text-sm font-medium text-slate-500 sm:text-base">{description}</p>
          ) : null}
        </div>
      </div>
      {actions ? <ActionBar className="sm:max-w-[min(100%,24rem)]">{actions}</ActionBar> : null}
    </div>
  );
}
